const constants = {
  STOPS: {
    ALL_STOPS: "All Bills",
    SELECT_STOPS: "Selected bills from list of all bills",
    ALL_DELIVERIES: "All deliveries",
    ALL_PICKUPS: "All pickups"
  },
  RETURN_DELIVERY_CODE: "RTN",
  MOVE_STATUS: {
    ALL_PICKUPS_AND_DELIVERIES: "AllPickupsAndDeliveries",
    ALL_PICKUPS_AND_RETURNS: "AllPickupsAndReturns",
    ALL_PICKUPS: "AllPickups",
    ALL_DELIVERIES: "AllDeliveries",
    ALL_RETURNS: "AllReturns",
    INDIVIDUAL_PRO: "IndividualPro",
  },
  MESSAGES: {
    REQUIRED: "* Required",
    SUCCESS: "Bills updated successfully",
    FAILURE: "Error while updating bills",
    BILL_REQUIRED: "At least one bill is required!",
    NO_STOP_FROUND: "No stops found!",
    INVALID_TO_TRAILER_STATUS: "Not a valid trailer status to move bills",
    NO_BILLS: "There are no bills in the trailer",
    DELAYED: "Move Bills is taking more time",
    INPROGRESS: "Move Bills is in progress"
  }
}

export default constants;